import JavaInstall from "../../../../contents/docs/integrate/_snippets/install-java.mdx";
import JavaSendEvents from "../../../../contents/docs/integrate/send-events/_snippets/send-events-java.mdx";
import FeatureFlagsLibsIntro from "../../../../contents/docs/libraries/_snippets/feature-flags-libs-intro.mdx";
import * as React from 'react';
export default {
  JavaInstall,
  JavaSendEvents,
  FeatureFlagsLibsIntro,
  React
};